// Get Members
export const GET_MEMBERS_REQUEST = 'GET_MEMBERS_REQUEST';
export const GET_MEMBERS_DONE = 'GET_MEMBERS_DONE';
export const GET_MEMBERS_FAILED = 'GET_MEMBERS_FAILED';

// Delete Member
export const DELETE_MEMBER_REQUEST = 'DELETE_MEMBER_REQUEST';
export const DELETE_MEMBER_DONE = 'DELETE_MEMBER_DONE';
export const DELETE_MEMBER_FAILED = 'DELETE_MEMBER_FAILED';
export const DELETE_MEMBER_RESET = 'DELETE_MEMBER_RESET';

// Save Columns Width
export const SAVE_MEMBERS_COLUMNS = 'SAVE_MEMBERS_COLUMNS';

// Operations
export const MEMBERS_SET_PAGE = 'MEMBERS_SET_PAGE';